import React from "react";
import Purchases from "./Purchases";
import withTabs from "../../../../components/withTabs";

export default withTabs(Purchases);
